import { INITIAL_SAVE_REQUEST_META } from '../utils';
import { BrowsingModeWidgetData } from './types';

const defaultBrowsingModeWidgetData: NonNullable<BrowsingModeWidgetData['initialData']> = {
  contentFilter: 'standard',
  contentFilterList: [],
};

export const defaultBrowsingModeWidgetState: BrowsingModeWidgetData = {
  initialData: defaultBrowsingModeWidgetData,
  currentData: defaultBrowsingModeWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
